import { render, staticRenderFns } from "./busInformation.vue?vue&type=template&id=61884bd0&scoped=true&"
import script from "./busInformation.vue?vue&type=script&lang=js&"
export * from "./busInformation.vue?vue&type=script&lang=js&"
import style0 from "./busInformation.vue?vue&type=style&index=0&id=61884bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61884bd0",
  null
  
)

export default component.exports